<template>
  <div class="wrapper-paper line-numbers">
    <div v-if="subject_id == 3">
      <el-button @click="CloseDrawer" size="medium" v-if="drawer" style="position: fixed;z-index: 10000; float: right;top:12px;right:10px; background: #66b1ff7d;
                        color: white;
                        border: 0px;">
        <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
          <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
          <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
          <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
        </svg>
        返回试卷
      </el-button>

      <el-button @click="OpenDrawer" size="medium" v-if="drawer" style="position: fixed;z-index: 10000; float: right;top:12px;right: 140px; background: #66b1ff7d;
                        color: white;
                        border: 0px;">
        <svg t="1665543507850" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4723" width="15" height="15">
          <path d="M811.115789 1005.136842H212.884211a194.290526 194.290526 0 0 1-194.021053-194.021053V212.884211A194.290526 194.290526 0 0 1 212.884211 18.863158h598.231578a194.290526 194.290526 0 0 1 194.021053 194.021053v598.231578a194.290526 194.290526 0 0 1-194.021053 194.021053zM212.884211 72.757895a140.126316 140.126316 0 0 0-140.126316 140.126316v598.231578a140.126316 140.126316 0 0 0 140.126316 140.126316h598.231578a140.126316 140.126316 0 0 0 140.126316-140.126316V212.884211a140.126316 140.126316 0 0 0-140.126316-140.126316z" p-id="4724" fill="#ffffff"></path>
          <path d="M788.210526 350.315789H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 350.315789H233.903158a26.947368 26.947368 0 0 1 0-53.894736h58.206316a26.947368 26.947368 0 0 1 0 53.894736zM788.210526 538.947368H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 540.564211H233.903158a26.947368 26.947368 0 0 1 0-53.894737h58.206316a26.947368 26.947368 0 0 1 0 53.894737zM788.210526 745.094737H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 746.442105H233.903158a26.947368 26.947368 0 1 1 0-53.894737h58.206316a26.947368 26.947368 0 0 1 0 53.894737z" p-id="4725" fill="#ffffff"></path>
        </svg>
        题目说明
      </el-button>
    </div>

    <div v-if="subject_id == 2">
      <el-button @click="CloseDrawer" size="medium" v-if="drawer" style="position: fixed;z-index: 10000; float: right;top:8px;right: 10px; background: #66b1ff7d;
                        color: white;
                        border: 0px;">
        <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
          <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
          <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
          <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
        </svg>
        返回
      </el-button>

      <el-button @click="OpenDrawer" size="medium" v-if="drawer" style="position: fixed;z-index: 10000;  float: right;top:8px;right: 110px; background: #66b1ff7d;
                        color: white;
                        border: 0px;">
        <svg t="1665543507850" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4723" width="15" height="15">
          <path d="M811.115789 1005.136842H212.884211a194.290526 194.290526 0 0 1-194.021053-194.021053V212.884211A194.290526 194.290526 0 0 1 212.884211 18.863158h598.231578a194.290526 194.290526 0 0 1 194.021053 194.021053v598.231578a194.290526 194.290526 0 0 1-194.021053 194.021053zM212.884211 72.757895a140.126316 140.126316 0 0 0-140.126316 140.126316v598.231578a140.126316 140.126316 0 0 0 140.126316 140.126316h598.231578a140.126316 140.126316 0 0 0 140.126316-140.126316V212.884211a140.126316 140.126316 0 0 0-140.126316-140.126316z" p-id="4724" fill="#ffffff"></path>
          <path d="M788.210526 350.315789H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 350.315789H233.903158a26.947368 26.947368 0 0 1 0-53.894736h58.206316a26.947368 26.947368 0 0 1 0 53.894736zM788.210526 538.947368H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 540.564211H233.903158a26.947368 26.947368 0 0 1 0-53.894737h58.206316a26.947368 26.947368 0 0 1 0 53.894737zM788.210526 745.094737H439.781053a25.6 25.6 0 1 1 0-50.930526h348.429473a25.6 25.6 0 0 1 0 50.930526zM292.109474 746.442105H233.903158a26.947368 26.947368 0 1 1 0-53.894737h58.206316a26.947368 26.947368 0 0 1 0 53.894737z" p-id="4725" fill="#ffffff"></path>
        </svg>
        题目
      </el-button>
    </div>

    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: backPath }">返回</el-breadcrumb-item>
        <el-breadcrumb-item>题库预览</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-row class="question" :gutter="20">
      <el-col :span="18">
        <el-card shadow="never">
          <div class="question-wrapper">
            <el-row>
              <el-col :span="24">
                <div class="question-header">
                  <span class="question-label">{{ title }}</span>
                </div>
              </el-col>
            </el-row>

            <div style="margin-top: 20px" v-if="form_state.onechoice_num > 0">
              <el-tag size="mini" style="background:#3a8ee6;border:1px solid #3a8ee6;" effect="dark" type="info">单选题</el-tag>
              <span style="margin-left: 10px">(共{{ form_state.onechoice_num }}题)</span>
            </div>

            <div v-for="(item, index) of form_state.onechoice_arr" :key="index" :id="item.index + 1">
              <div class="question-content">
                <div class="question-info">
                  <span style="font-size: 16px;float:left;">({{ index + 1 }})</span>

                  <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                  <span class="question-title" v-else>
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </span>
                  <!-- <span class="question-score">({{ paperQuestionList[item.index].score }}分)
                  </span> -->
                </div>

                <div class="answer-options" v-if="item.show_type === 1">
                  <div class="option-wrapper" v-for="(option, optionIndex) of JSON.parse(item.options)" :key="`${item.id}_${optionIndex}_option`">
                    <span class="option-tab">
                      <el-radio v-if="option.content != ''" v-model="item.radio" :label="option.title">{{ option.title }}</el-radio>
                    </span>

                    <div v-if="option.content != ''" class="option-input" v-html="option.content"></div>
                  </div>
                </div>
                <div class="answer-options" v-else>
                  <div class="option-wrapper" v-for="(option, optionIndex) of JSON.parse(item.options_md)" :key="`${item.id}_${optionIndex}_option_md`">
                    <span class="option-tab">
                      <el-radio v-if="option.content != ''" v-model="item.radio" :label="option.title">{{ option.title }}</el-radio>
                    </span>

                    <div class="option-input" v-if="option.content != ''">
                      <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="option.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                  </div>
                </div>
              </div>

              <el-row>
                <el-col :span="24">
                  <div class="answer-check">
                    <div>
                      <span class="correct_label">正确答案:</span>
                      <span class="correct_answer">{{ item.answer }}</span>
                      <!--

                      <span class="myanswer_label">我的答案:</span>
                      <span class="myanswer">D</span>

                      <span class="wrong"
                        ><i class="el-icon-error"></i>错误</span
                      >

                      <span class="correct"
                        ><i class="el-icon-success"></i>正确</span
                      >
                      -->
                    </div>
                  </div>
                </el-col>
              </el-row>

              <div class="resolution">
                <div class="recolution-title">试题解析:</div>
                <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                <div class="resolution-content" v-else>
                  <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                </div>
              </div>

              <el-divider></el-divider>
            </div>

            <div style="margin-top: 20px" v-if="form_state.multi_choice_num > 0">
              <el-tag size="mini" style="background:#3a8ee6;border:1px solid #3a8ee6;" effect="dark" type="info">多选题</el-tag>
              <span style="margin-left: 10px">(共{{ form_state.multi_choice_num }}题)</span>
            </div>

            <div v-for="(item, index) of form_state.multi_choice_arr" :key="index" :id="item.index + 1">
              <div class="question-content">
                <div class="question-info">
                  <el-tag class="question-sort" size="mini" type="info" effect="plain">{{ index + 1 }}</el-tag>

                  <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                  <span class="question-title" v-else>
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </span>
                  <!-- <span class="question-score">({{ paperQuestionList[item.index].score }}分)
                  </span> -->
                </div>

                <div class="answer-options" v-if="item.show_type === 1">
                  <!-- 
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(item.options)" :key="index">
                      <span class="option-tab">
                      <el-checkbox v-model="item.checked" :label="option.title">{{ option.title }}</el-checkbox>
                   -->
                  <div class="option-wrapper" v-for="(option, optionIndex) of JSON.parse(item.options)" :key="`${item.id}_${optionIndex}_option`">
                    <span class="option-tab">
                      <el-checkbox @change="checkAddType" v-model="item.answers[optionIndex]" :label="option.title">{{ option.title }}</el-checkbox>

                      <!-- <el-radio v-model="radio" :label="option.title">{{
                        option.title
                      }}</el-radio> -->
                    </span>

                    <div class="option-input" v-html="option.content"></div>
                  </div>
                </div>
                <div class="answer-options" v-else>
                  <!-- 
                    <div class="option-wrapper" v-for="(option, index) of JSON.parse(item.options_md)" :key="index">
                    <span class="option-tab">
                      <el-checkbox v-model="item.checked" :label="option.title">{{ option.title }}</el-checkbox>
                   -->
                  <div class="option-wrapper" v-for="(option, optionIndex) of JSON.parse(item.options_md)" :key="`${item.id}_${optionIndex}_option_md`">
                    <span class="option-tab">
                      <el-checkbox @change="checkAddType" v-model="item.answers[optionIndex]" :label="option.title">{{ option.title }}</el-checkbox>

                      <!-- <el-radio v-model="radio" :label="option.title">{{
                        option.title
                      }}</el-radio> -->
                    </span>

                    <div class="option-input">
                      <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="option.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                  </div>
                </div>
              </div>

              <el-row>
                <el-col :span="24">
                  <div class="answer-check">
                    <div>
                      <span class="correct_label">正确答案:</span>
                      <span class="correct_answer">{{ item.answer }}</span>
                      <!--

                      <span class="myanswer_label">我的答案:</span>
                      <span class="myanswer">D</span>

                      <span class="wrong"
                        ><i class="el-icon-error"></i>错误</span
                      >

                      <span class="correct"
                        ><i class="el-icon-success"></i>正确</span
                      >
                      -->
                    </div>
                  </div>
                </el-col>
              </el-row>

              <div class="resolution">
                <div class="recolution-title">试题解析:</div>
                <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                <div class="resolution-content" v-else>
                  <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                </div>
              </div>

              <el-divider></el-divider>
            </div>

            <div style="margin-top: 20px" v-if="form_state.judge_choice_num > 0">
              <el-tag size="mini" style="background:#3a8ee6;border:1px solid #3a8ee6;" effect="dark" type="info">判断题</el-tag>
              <span style="margin-left: 10px">(共{{ form_state.judge_choice_num }}题)</span>
            </div>

            <div v-for="(item, index) of form_state.judge_choice_arr" :key="index" :id="item.index + 1">
              <div class="question-content">
                <div class="question-info">
                  <span style="font-size: 16px;float:left;">({{ index + 1 }})</span>
                  <!-- <span class="question-title" v-html="item.title"></span> -->
                  <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                  <span class="question-title" v-else>
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </span>
                  <!-- <span class="question-score">({{ paperQuestionList[item.index].score }}分)
                  </span> -->
                </div>

                <div class="answer-options">
                  <div v-for="(option,index) of JSON.parse(item.options)" :key="`${item.id}_${index}_option`">
                    <div v-if="option.content != ''" class="option-wrapper">
                      <span class="option-tab">
                        <el-radio v-model="item.radio" :label="option.title">{{
                          option.title
                        }}</el-radio>
                      </span>

                      <div class="option-input" v-html="option.content"></div>
                    </div>
                  </div>
                </div>
              </div>

              <el-row>
                <el-col :span="24">
                  <div class="answer-check">
                    <div>
                      <span class="correct_label">正确答案:</span>
                      <span class="correct_answer">{{ item.answer }}</span>
                      <!--

                      <span class="myanswer_label">我的答案:</span>
                      <span class="myanswer">D</span>

                      <span class="wrong"
                        ><i class="el-icon-error"></i>错误</span
                      >

                      <span class="correct"
                        ><i class="el-icon-success"></i>正确</span
                      >
                      -->
                    </div>
                  </div>
                </el-col>
              </el-row>

              <div class="resolution">
                <div class="recolution-title">试题解析:</div>
                <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                <div class="resolution-content" v-else>
                  <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                </div>
              </div>

              <el-divider></el-divider>
            </div>

            <div style="margin-top: 20px" v-if="form_state.space_choice_num > 0">
              <el-tag size="mini" style="background:#3a8ee6;border:1px solid #3a8ee6;" effect="dark" type="info">填空题</el-tag>
              <span style="margin-left: 10px">(共{{ form_state.space_choice_num }}题)</span>
            </div>

            <div v-for="(item, index) of form_state.space_choice_arr" :key="index" :id="item.index + 1">
              <div class="question-content">
                <div class="question-info">
                  <el-tag class="question-sort" size="mini" type="info" effect="plain">{{ index + 1 }}</el-tag>

                  <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                  <span class="question-title" v-else>
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </span>
                </div>
              </div>

              <el-row>
                <el-col :span="24">
                  <div class="answer-check">
                    <div>
                      <span class="correct_label">正确答案:</span>
                      <span class="correct_answer" v-for="count in item.tiankong_num" :key="count">
                        <div style="overflow: hidden;">
                          <div style="float: left; color: #333;line-height: 32px; margin-right: 10px;margin-top: 5px;">
                            {{ count }}.
                          </div>
                          <div style="float: left; margin-top: 5px;">
                            <input style="padding: 5px" :placeholder="
                                '请输入第' + count + '个空的作答内容'
                              " v-model="item.answer.split('┅')[count - 1]" />
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <div class="resolution">
                <div class="recolution-title">试题解析:</div>
                <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                <div class="resolution-content" v-else>
                  <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                </div>
              </div>

              <el-divider></el-divider>
            </div>

            <div style="margin-top: 20px" v-if="form_state.blank_choice_num > 0">
              <el-tag size="mini" style="background:#3a8ee6;border:1px solid #3a8ee6;" effect="dark" type="info">简单题</el-tag>
              <span style="margin-left: 10px">(共{{ form_state.blank_choice_num }}题)</span>
            </div>

            <div v-for="(item, index) of form_state.blank_choice_arr" :key="item.id" :id="item.index + 1">
              <div class="question-content">
                <div class="question-info">
                  <span style="font-size: 16px;float:left;">({{ index + 1 }})</span>

                  <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                  <span class="question-title" v-else>
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </span>
                  <!-- <span class="question-score">({{ paperQuestionList[item.index].score }}分)
                  </span> -->
                </div>
              </div>

              <el-row>
                <el-col :span="24">
                  <div class="answer-check">
                    <div>
                      <span class="correct_label">正确答案:</span>
                      <span class="correct_answer" v-html="item.answer"></span>
                      <!--

                      <span class="myanswer_label">我的答案:</span>
                      <span class="myanswer">D</span>

                      <span class="wrong"
                        ><i class="el-icon-error"></i>错误</span
                      >

                      <span class="correct"
                        ><i class="el-icon-success"></i>正确</span
                      >
                      -->
                    </div>
                  </div>
                </el-col>
              </el-row>

              <div class="resolution">
                <div class="recolution-title">试题解析:</div>
                <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                <div class="resolution-content" v-else>
                  <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                </div>
              </div>

              <el-divider></el-divider>
            </div>
            <!-- 综合题 -->
            <div style="margin-top: 20px" v-if="form_state.comprehensive_choice_num > 0">
              <el-tag size="mini" style="background:#3a8ee6;border:1px solid #3a8ee6;" effect="dark" type="info">综合题</el-tag>
              <span style="margin-left: 10px">(共{{ form_state.comprehensive_choice_num }}题)</span>
            </div>
            <div v-for="(item, index) of form_state.comprehensive_choice_arr" :key="index" :id="item.index + 1">
              <div class="question-content">
                <div class="question-info">
                  <span style="font-size: 16px;float:left;">({{ index + 1 }})</span>

                  <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                  <span class="question-title" v-else>
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </span>
                  <!-- <span class="question-score">({{ paperQuestionList[item.index].score }}分)
                  </span> -->
                </div>
              </div>

              <el-row>
                <el-col :span="24">
                  <div class="answer-check">
                    <div>
                      <span class="correct_label">正确答案:</span>
                      <el-button style="margin-left: 20px" size="mini" type="primary" @click="QuestionModal(item)">挑战模板
                      </el-button>
                      <el-button size="mini" type="primary" @click="QuestionAnswer(item)">正确源码</el-button>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <div class="resolution">
                <div class="recolution-title">试题解析:</div>
                <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                <div class="resolution-content" v-else>
                  <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                </div>
              </div>

              <el-divider></el-divider>
            </div>
            <!-- 阅读程序题 -->
            <div style="margin:20px 0 " v-if="form_state.ReadingProgramNum > 0">
              <el-tag size="mini" style="background:#3a8ee6;border:1px solid #3a8ee6;" effect="dark" type="info">阅读程序题</el-tag>
              <span style="margin-left: 10px">(共{{ form_state.ReadingProgramNum }}题)</span>
            </div>
            <div v-for="item1 of form_state.ReadingProgramNumList" :key="item1.id">
              <span v-if="item1.typeShow == 1">
                <span class="question-title" v-html="item1.title_other"></span>
              </span>
              <span v-else>
                <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item1.title_other_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </span>
              <div v-for="(item, index) of item1.arr" :key="item.id" :id="item.index + 1">
                <div v-if="item.type_other == 1">
                  <div class="question-content">
                    <div class="question-info">
                      <span style="font-size: 16px;float:left;">({{ index + 1 }})</span>

                      <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                      <span class="question-title" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </span>
                    </div>

                    <div class="answer-options" v-if="item.show_type === 1">
                      <div class="option-wrapper" v-for="option of JSON.parse(item.options)" :key="option.id">
                        <span class="option-tab">
                          <el-radio v-if="option.content != ''" v-model="item.radio" :label="option.title">{{ option.title }}
                          </el-radio>
                        </span>
                        <div class="option-input" v-if="option.content != ''" v-html="option.content"></div>
                      </div>
                    </div>
                    <div class="answer-options" v-else>
                      <div class="option-wrapper" v-for="option of JSON.parse(item.options_md)" :key="option.id">
                        <span class="option-tab">
                          <el-radio v-if="option.content != ''" v-model="item.radio" :label="option.title">{{ option.title }}
                          </el-radio>
                        </span>
                        <div class="option-input" v-if="option.content != ''">
                          <mavon-editor z-index="9999" :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="option.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                        </div>
                      </div>
                    </div>
                  </div>

                  <el-row>
                    <el-col :span="24">
                      <div class="answer-check">
                        <div style="float: left;">
                          <span class="correct_label">正确答案:</span>
                          <span v-if="item.isShow" class="correct_answer">{{
                            item.answer
                          }}</span>
                        </div>
                        <div style="float: right;">
                          <el-switch active-text="显示答案" inactive-text="" v-model="item.isShow" active-color="green" inactive-color="grey">
                          </el-switch>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="resolution">
                    <div class="recolution-title">试题解析:</div>
                    <div v-if="item.isShow">
                      <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                      <div class="resolution-content" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </div>
                  </div>

                  <el-divider></el-divider>
                </div>
                <div v-if="item.type_other == 3">
                  <div class="question-content">
                    <div class="question-info">
                      <el-tag class="question-sort" size="mini" type="info" effect="plain">{{ index + 1 }}</el-tag>

                      <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                      <span class="question-title" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </span>
                    </div>

                    <div class="answer-options">
                      <div class="option-wrapper" v-for="option of JSON.parse(item.options)" :key="option.id">
                        <span class="option-tab" v-if="option.content">
                          <el-radio v-model="item.radio" :label="option.title">{{ option.title }}</el-radio>
                        </span>

                        <div class="option-input" v-if="option.content" v-html="option.content"></div>
                      </div>
                    </div>
                  </div>

                  <el-row>
                    <el-col :span="24">
                      <div class="answer-check">
                        <div style="float: left;">
                          <span class="correct_label">正确答案:</span>
                          <span class="correct_answer" v-if="item.isShow">{{
                            item.answer
                          }}</span>
                        </div>
                        <div style="float: right;">
                          <el-switch active-text="显示答案" inactive-text="" v-model="item.isShow" active-color="green" inactive-color="grey">
                          </el-switch>
                        </div>
                      </div>
                    </el-col>
                  </el-row>

                  <div class="resolution">
                    <div class="recolution-title">试题解析:</div>
                    <div v-if="item.isShow">
                      <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                      <div class="resolution-content" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </div>
                  </div>

                  <el-divider></el-divider>
                </div>
              </div>
            </div>
            <!-- 完善程序题 -->
            <div style="margin-top: 20px;margin-bottom: 20px;" v-if="form_state.ImproveTheProgramNum > 0">
              <el-tag size="mini" style="background:#3a8ee6;border:1px solid #3a8ee6;" effect="dark" type="info">完善程序题</el-tag>
              <span style="margin-left: 10px">(共{{ form_state.ImproveTheProgramNum }}题)</span>
            </div>
            <div v-for="item1 of form_state.ImproveTheProgramNumList" :key="item1.id">
              <span v-if="item1.typeShow == 1">
                <span class="question-title" v-html="item1.title_other"></span>
              </span>
              <span v-else>
                <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item1.title_other_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
              </span>
              <div v-for="(item, index) of item1.arr" :key="item.id" :id="item.index + 1">
                <div v-if="item.type_other == 1">
                  <div class="question-content">
                    <div class="question-info">
                      <span style="font-size: 16px;float:left;">({{ index + 1 }})</span>

                      <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                      <span class="question-title" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </span>
                    </div>

                    <div class="answer-options" v-if="item.show_type === 1">
                      <div class="option-wrapper" v-for="option of JSON.parse(item.options)" :key="option.id">
                        <span class="option-tab">
                          <el-radio v-if="option.content != ''" v-model="item.radio" :label="option.title">{{ option.title }}</el-radio>
                        </span>

                        <div class="option-input" v-if="option.content != ''" v-html="option.content"></div>
                      </div>
                    </div>
                    <div class="answer-options" v-else>
                      <div class="option-wrapper" v-for="option of JSON.parse(item.options_md)" :key="option.id">
                        <span class="option-tab">
                          <el-radio v-if="option.content != ''" v-model="item.radio" :label="option.title">{{ option.title }}</el-radio>
                        </span>
                        <div class="option-input" v-if="option.content != ''">
                          <mavon-editor z-index="9999" :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="option.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                        </div>
                      </div>
                    </div>
                  </div>

                  <el-row>
                    <el-col :span="24">
                      <div class="answer-check">
                        <div style="float: left;">
                          <span class="correct_label">正确答案:</span>
                          <span v-if="item.isShow" class="correct_answer">{{
                            item.answer
                          }}</span>
                        </div>
                        <div style="float: right;">
                          <el-switch active-text="显示答案" inactive-text="" v-model="item.isShow" active-color="green" inactive-color="grey">
                          </el-switch>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="resolution">
                    <div class="recolution-title">试题解析:</div>
                    <div v-if="item.isShow">
                      <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                      <div class="resolution-content" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </div>
                  </div>

                  <el-divider></el-divider>
                </div>
                <div v-if="item.type_other == 3">
                  <div class="question-content">
                    <div class="question-info">
                      <span style="font-size: 16px;float:left;">({{ index + 1 }})</span>
                      <span class="question-title" v-html="item.title" v-if="item.show_type === 1"></span>
                      <span class="question-title" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </span>
                    </div>

                    <div class="answer-options">
                      <div class="option-wrapper" v-for="option of JSON.parse(item.options)" :key="option.id">
                        <span class="option-tab" v-if="option.content">
                          <el-radio v-model="item.radio" :label="option.title">{{ option.title }}</el-radio>
                        </span>

                        <div class="option-input" v-if="option.content" v-html="option.content"></div>
                      </div>
                    </div>
                  </div>

                  <el-row>
                    <el-col :span="24">
                      <div class="answer-check">
                        <div style="float: left;">
                          <span class="correct_label">正确答案:</span>
                          <span class="correct_answer" v-if="item.isShow">{{
                            item.answer
                          }}</span>
                        </div>
                        <div style="float: right;">
                          <el-switch active-text="显示答案" inactive-text="" v-model="item.isShow" active-color="green" inactive-color="grey">
                          </el-switch>
                        </div>
                      </div>
                    </el-col>
                  </el-row>

                  <div class="resolution">
                    <div class="recolution-title">试题解析:</div>
                    <div v-if="item.isShow">
                      <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                      <div class="resolution-content" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </div>
                  </div>

                  <el-divider></el-divider>
                </div>
              </div>
            </div>
            <!-- 编程题 -->
            <div style="margin-top: 20px" v-if="form_state.programmingProblemNum > 0">
              <el-tag size="mini" style="background:#3a8ee6;border:1px solid #3a8ee6;" effect="dark" type="info">编程题</el-tag>
              <span style="margin-left: 10px">(共{{ form_state.programmingProblemNum }}题)</span>
            </div>

            <div v-for="(item, index) of form_state.programmingProblemList" :key="item.id" :id="item.index + 1">
              <div class="question-content">
                <div class="question-info">
                  <span style="font-size: 16px;float:left;">({{ index + 1 }})</span>
                  <span class="question-title"> {{item.ojProblemInfo.code}} {{item.ojProblemInfo.title}}</span>
                  <!-- <span class="question-score">({{ paperQuestionList[item.index].score }}分)
                  </span> -->
                </div>
                <!-- show_type=1 是editor =2是md -->
                <div class="question-body" style="padding-top:10px;margin-bottom:20px;font-size:16px">
                  <template v-if="item.ojProblemInfo.description_show_type === 1">
                    <div class="desc">
                      <strong style="display: inline-block;width:100%">描述</strong>
                      <span v-html="item.ojProblemInfo.description"></span>
                    </div>
                    <div class="desc-input" style="margin-bottom:10px;">
                      <strong>输入描述</strong>
                      <p v-html="item.ojProblemInfo.input_description"></p>
                    </div>
                    <div class="desc-output" style="margin-bottom:10px;">
                      <strong>输出描述</strong>
                      <p v-html="item.ojProblemInfo.output_description"></p>
                    </div>
                  </template>
                  <template v-else>
                    <div class="desc">
                      <strong style="display: inline-block;width:100%">描述</strong>
                      <mavon-editor :style="{ 'min-height': '0px','border':'none' }" preview-background="#fff" v-model="item.ojProblemInfo.md_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                    <div class="desc-input" style="margin-bottom:10px;">
                      <strong>输入描述</strong>
                      <mavon-editor :style="{ 'min-height': '0px','border':'none' }" preview-background="#fff" v-model="item.ojProblemInfo.md_input_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                    <div class="desc-output" style="margin-bottom:10px;">
                      <strong>输出描述</strong>
                      <mavon-editor :style="{ 'min-height': '0px','border':'none' }" preview-background="#fff" v-model="item.ojProblemInfo.md_output_description" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                    </div>
                  </template>
                  <div class="input-samples" style="margin-bottom:10px;">
                    <div v-for="(sample, i) in JSON.parse(item.ojProblemInfo.samples)" :key="i">
                      <strong class="title">输入样例 {{ i + 1 }}</strong>
                      <!-- <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags" :data-clipboard-text="sample.input" @click="copyText" size="mini">复制</el-tag></span> -->
                      <pre class="language-c" style="border:1px solid #ddd;padding:10px;border-radius:5px;margin-top:5px">{{ sample.input }}</pre>
                    </div>
                  </div>
                  <div class="output-samples" style="margin-bottom:10px;">
                    <div v-for="(sample, i) in JSON.parse(item.ojProblemInfo.samples)" :key="i">
                      <strong class="title">输出样例 {{ i + 1 }}</strong>
                      <!-- <span class="title" style="margin-left: 15px;cursor: pointer;"><el-tag class="tags" :data-clipboard-text="sample.output" @click="copyText" size="mini">复制</el-tag></span> -->
                      <pre class="language-c" style="border:1px solid #ddd;padding:10px;border-radius:5px;margin-top:5px">{{ sample.output }}</pre>
                    </div>
                  </div>
                </div>
              </div>

              <div style="overflow: hidden;">
                <div style="float: left;">
                  <el-row>
                    <el-col :span="24">
                      <div class="answer-check">
                        <div>
                          <span class="correct_label">查看题目:</span>
                          <!-- <span class="correct_answer" v-if="item.isShow" v-html="item.answer"></span> -->
                          <el-button v-if="item.isShow" style="margin-left:20px;" type="primary" size="small" round @click="handleCodeMirrorInfoDrawer(true,item)">开始编程</el-button>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="resolution">
                    <div class="recolution-title">
                      题目来源:
                      <span v-if="item.isShow" style="padding-left:20px">
                        {{ item.bankName }}
                      </span>
                    </div>
                  </div>
                  <div class="resolution" style="display:flex;align-items:center">
                    <div class="recolution-title" style="margin-right:20px">试题解析:</div>
                    <div v-if="item.isShow">
                      <!-- <div class="resolution-content" v-html="item.analysis" v-if="item.show_type === 1"></div>
                      <div class="resolution-content" v-else>
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="item.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div> -->
                      <el-button type="primary" size="small" round @click="handleProgrammingProblemDrawer(true,item)">查看解析</el-button>
                      <el-drawer title="试题解析" :with-header="false" size="100%" :visible.sync="form_state.programmingProblemShow" :direction="'ltr'">
                        <div class="analyze-content">
                          <div class="analyze-header">
                            <el-button icon="el-icon-back" style="backgroundColor:#4C95FC;border:none;color:#fff" @click="handleProgrammingProblemDrawer(false)">返回试卷</el-button>
                          </div>
                          <div class="analyze-body" v-if="analyzeList.join('')!==''">
                            <div class="analyze-left">
                              <div v-for="anItem in analyzeList" :key="anItem.id" @click="handleSelectedAnalyzeItem(anItem)" :class="{'analyze-left-item':true, active:analyzeItem.id===anItem.id}">
                                <div class="title">
                                  <img :src="anItem.headImg||'https://wugecdn.steam.fun/resources/static/images/logo.png'" alt="">
                                  <strong>{{anItem.title}}</strong>
                                  <span v-if="anItem.sort_type<3"><el-tag size="mini" effect="dark" :type="anItem.sort_type === 2?'success':''">{{anItem.sort_type === 1 ?"官方":anItem.sort_type === 2?'精选':''}}</el-tag></span>
                                </div>
                                <div class="content" v-html="anItem.content.replace(/<.+?>/g,'')"></div>
                              </div>
                              <div class="pagination">
                                <el-pagination @current-change="handleChangePage" :current-page.sync="analyzePage.page_no" layout="total, prev, pager, next" :page-size="analyzePage.page_size" :total="analyzePage.total"></el-pagination>
                              </div>
                            </div>
                            <div class="analyze-right" v-if="analyzeItem">
                              <div class="title">{{analyzeItem.title}}</div>
                              <div class="stu-info">
                                <img :src="analyzeItem.headImg|| 'https://wugecdn.steam.fun/resources/static/images/logo.png'" alt="">
                                <span>{{analyzeItem.realname||'格小C'}}</span>
                                <span>发布于: {{analyzeItem.update_time}}</span>
                              </div>
                              <div style="margin-bottom:20px">
                                <span v-if="analyzeItem.sort_type<3"><el-tag size="mini" effect="dark" :type="analyzeItem.sort_type === 2?'success':''">{{analyzeItem.sort_type === 1 ?"官方":analyzeItem.sort_type === 2 ?'精选':''}}</el-tag></span>
                                <span v-for="tagItem in analyzeItem.problemTagArr" :key="tagItem.id">
                                  <el-tag type="info" size="mini" style="margin-left: 10px;">{{ tagItem.tagInfo.title }}</el-tag>
                                </span>
                                <span v-for="langItem in JSON.parse(analyzeItem.languages||'[]')" :key="langItem.id">
                                  <el-tag type="info" size="mini" style="margin-left: 10px;">
                                    {{langItem === '0'?'C':langItem==='1'?'C++':langItem==='2'?'Python3':''}}
                                  </el-tag>
                                </span>
                              </div>
                              <!-- <CodeMirrorComponent v-if="analyzeItem" v-model="analyzeItem.content" /> -->
                              <!-- 解析视频 -->
                              <div class="video-box" v-if="analyzeItem.video_url_arr">
                                <div class="title" v-if="JSON.parse(analyzeItem.video_url_arr).length > 0">
                                  <svg t="1724310100931" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3404" width="28" height="28">
                                    <path d="M849.170732 0c97.404878 0 174.829268 77.42439 174.829268 174.829268v674.341464c0 97.404878-77.42439 174.829268-174.829268 174.829268H174.829268c-97.404878 0-174.829268-77.42439-174.829268-174.829268V174.829268c0-97.404878 77.42439-174.829268 174.829268-174.829268h674.341464z m-239.765854 299.707317H252.253659c-27.473171 0-49.95122 19.980488-52.448781 47.453659V691.82439c0 27.473171 19.980488 49.95122 47.453659 52.448781h362.146341c27.473171 0 49.95122-19.980488 52.448781-47.453659v-27.473171L699.317073 699.317073c14.985366 12.487805 37.463415 14.985366 54.946342 4.995122 17.482927-7.492683 27.473171-24.97561 27.47317-42.458536v-274.731708c0-19.980488-9.990244-37.463415-29.970731-44.956097-17.482927-7.492683-34.965854-7.492683-49.95122 2.497561l-2.497561 2.497561-39.960975 29.970731V349.658537c0-27.473171-19.980488-49.95122-47.453659-52.448781l-2.497561 2.497561z m-244.760976 137.365854c4.995122-2.497561 9.990244-2.497561 14.985366 0l2.497561 2.497561 104.897561 69.931707c4.995122 2.497561 7.492683 7.492683 7.492683 14.985366 0 4.995122-2.497561 9.990244-4.995122 12.487805l-2.497561 2.497561-107.395122 72.429268c-4.995122 2.497561-12.487805 4.995122-17.482927 0-4.995122-2.497561-7.492683-7.492683-9.990243-12.487805v-144.858536c2.497561-9.990244 7.492683-14.985366 12.487804-17.482927z" fill="#2488ef" p-id="3405"></path>
                                  </svg>
                                  <span>视频解析</span>
                                </div>
                                <div class="content" v-if="JSON.parse(analyzeItem.video_url_arr).length > 0">
                                  <div style="margin-top:20px;" v-for="(videoItemUrl, videoIndex) in JSON.parse(
                          analyzeItem.video_url_arr
                        )" :key="videoIndex">
                                    <video :src="videoItemUrl" controls="controls" controlslist="nodownload"></video>
                                  </div>
                                </div>
                              </div>
                              <!-- <div style="margin-top:10px" v-html="content.content"></div> -->

                              <div v-if="analyzeItem.video_url_arr">
                                <el-divider v-if="JSON.parse(analyzeItem.video_url_arr).length > 0"></el-divider>
                              </div>

                              <mavon-editor :style="{ 'min-height': '0px' }" preview-background="transparent" v-model="analyzeItem.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                            </div>
                          </div>
                        </div>
                      </el-drawer>
                    </div>
                  </div>
                </div>
                <div style="float: right;">
                  <el-switch active-text="显示答案" inactive-text="" v-model="item.isShow" active-color="green" inactive-color="grey">
                  </el-switch>
                </div>
              </div>
              <el-divider></el-divider>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="never">
          <div class="answer-card">
            <div v-if="form_state.onechoice">
              <span class="onechoice">单选题</span>
            </div>

            <div class="choice_item" v-if="form_state.onechoice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.onechoice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type, item)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.multi_choice">
              <span>多选题</span>
            </div>

            <div class="choice_item" v-if="form_state.multi_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.multi_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type, item)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.judge_choice">
              <span>判断题</span>
            </div>

            <div class="choice_item" v-if="form_state.judge_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.judge_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type, item)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.space_choice">
              <span>填空题</span>
            </div>

            <div class="choice_item" v-if="form_state.space_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.space_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type, item)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.blank_choice">
              <span>简答题</span>
            </div>

            <div class="choice_item" v-if="form_state.blank_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.blank_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type, item)">{{ index + 1 }}</el-tag>
            </div>

            <div class="multichoice" v-if="form_state.comprehensive_choice">
              <span>综合题</span>
            </div>

            <div class="choice_item" v-if="form_state.comprehensive_choice">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.comprehensive_choice_arr" :key="index" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type, item)">{{ index + 1 }}</el-tag>
            </div>
            <!-- 阅读程序题 -->
            <div class="multichoice" v-if="form_state.ReadingProgram">
              <span>阅读程序题</span>
            </div>
            <div class="choice_item" v-if="form_state.ReadingProgram">
              <div v-for="(item, index) of form_state.ReadingProgramNumList" :key="index">
                <div style="padding:5px;">第{{ index + 1 }}题</div>

                <el-tag size="medium" class="tag" v-bind:class="{
                    tag_select: current_num == itemChild.index,
                    tag_hasdone: itemChild.stu_answer,
                  }" type="info" v-for="(itemChild, index) of item.arr" :key="index" :label="itemChild.index + 1" @click.native="
                    ChooseQustion(itemChild.index, itemChild.type, itemChild)
                  ">{{ index + 1 }}
                </el-tag>
              </div>
            </div>
            <!-- 完善程序题 -->
            <div class="multichoice" v-if="form_state.ImproveTheProgram">
              <span>完善程序题</span>
            </div>
            <div class="choice_item" v-if="form_state.ImproveTheProgram">
              <div v-for="(item, index) of form_state.ImproveTheProgramNumList" :key="index">
                <div style="padding:5px;">第{{ index + 1 }}题</div>

                <el-tag size="medium" class="tag" v-bind:class="{
                    tag_select: current_num == itemChild.index,
                    tag_hasdone: itemChild.stu_answer,
                  }" type="info" v-for="(itemChild, index) of item.arr" :key="index" :label="itemChild.index + 1" @click.native="
                    ChooseQustion(itemChild.index, itemChild.type, itemChild)
                  ">{{ index + 1 }}
                </el-tag>
              </div>
            </div>
            <!-- 编程题 -->
            <div class="multichoice" v-if="form_state.programmingProblem">
              <span>编程题</span>
            </div>
            <div class="choice_item" v-if="form_state.programmingProblem">
              <el-tag size="medium" class="tag" v-bind:class="{
                  tag_select: current_num == item.index,
                  tag_hasdone: item.stu_answer,
                }" type="info" v-for="(item, index) of form_state.programmingProblemList" :key="item.id" :label="item.index + 1" @click.native="ChooseQustion(item.index, item.type)">{{ index + 1 }}</el-tag>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-drawer :with-header="false" :visible.sync="drawer" direction="ltr" size="100%">
      <iframe id="exam_iframe" width="100%" height="100%" class="course-view" :src="exam_url" v-if="exam_url"></iframe>
      <el-drawer :with-header="false" title="题目说明" direction="ltr" :append-to-body="true" :visible.sync="innerDrawer">
        <div style="padding:20px;">
          <div style="font-size:20px;font-weight:500;">题目说明</div>
          <el-divider></el-divider>
          <div v-if="showType === 1" style="font-size:16px;" v-html="problem_desc" />
          <div v-else style="font-size:16px;">
            <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="problem_desc" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
          </div>
        </div>
      </el-drawer>
    </el-drawer>

    <el-drawer title="试题解析" :with-header="false" size="100%" :visible.sync="codeMirrorInfoShow" :direction="'ltr'">
      <div class="codemirror-info-container">
        <div class="codemirror-header">
          <el-button icon="el-icon-back" style="backgroundColor:#4C95FC;border:none;color:#fff" @click="handleCodeMirrorInfoDrawer(false)">返回试卷</el-button>
        </div>
        <codeMirrorInfoComponent v-if="CurrentQuestion && codeMirrorInfoShow" :canSubmit="true" :useOldApi="true" :CurrentQuestion="CurrentQuestion.ojProblemInfo" :stuExamQuestionId="CurrentQuestion.stuExamQuestionInfo?String(CurrentQuestion.stuExamQuestionInfo.id):''" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
// import Prism from "prismjs"; //引入插件
// import "prismjs/themes/prism-okaidia.css";
import { getSchoolQuestionList, tchGetOjProblemAnalysisList } from '@/api/educational'
import Axios from 'axios'

import Prism from 'prismjs'
import 'prismjs/themes/prism-twilight.css' // you can change
import Clipboard from "clipboard";

import getcode from '@/config/getCodesStyle'
// import markdownShow from "@/components/markdownShow";
// import CodeMirrorComponent from "@/components/CodeMirror";
import codeMirrorInfoComponent from '@/components/codeMirrorInfo.vue'

export default {
  name: 'CommonExam-Questionlist1',
  components: {
    codeMirrorInfoComponent
  },
  data() {
    return {
      problemItem: null,
      analyzeList: [],
      analyzeItem: null,
      analyzePage: {
        page_no: 1,
        page_size: 10,
        total: 0
      },
      codeMirrorInfoShow: false,

      ReadingProgramNumList1: [],
      ReadingProgramNumList2: [],
      showType: 1,
      title: '',
      model: '',
      radio_num: '1', //题号
      radio: '',
      auto_change: true,
      show_answer: true,
      form: {
        question_a: "print('Hello World')",
        question_b: '',
        question_c: '',
        question_d: '',
        resolution: '这个问题,应该这样回答？',
      },

      //题库试题状态
      form_state: {
        // 阅读程序题
        ReadingProgramNumList: [],
        ReadingProgramNum: 0,
        ReadingProgram: false,
        // 完善程序题
        ImproveTheProgramNum: 0,
        ImproveTheProgramNumList: [],
        ImproveTheProgram: false,
        // 编程题
        programmingProblemShow: false,
        programmingProblemNum: 0,
        programmingProblemList: [],
        programmingProblem: false,
        // 单选题
        onechoice: false,
        onechoice_num: 0,
        onechoice_score: 0,
        onechoice_arr: [],
        multi_choice: false,
        multi_choice_num: 0,
        multi_choice_score: 0,
        multi_choice_arr: [],
        judge_choice: false,
        judge_choice_num: 0,
        judge_choice_score: 0,
        judge_choice_arr: [],
        space_choice: false,
        space_choice_num: 0,
        space_choice_score: 0,
        space_choice_arr: [],
        blank_choice: false,
        blank_choice_num: 0,
        blank_choice_score: 0,
        blank_choice_arr: [],
        comprehensive_choice: false,
        comprehensive_choice_num: 0,
        comprehensive_choice_score: 0,
        comprehensive_choice_arr: [],
      },

      paperQuestionList: [], //试题列表
      questionlist: [],
      total_score: 0,
      question_num: 0,
      current_num: 0, //当前题

      //源码预览
      project_url: '',
      exam_url: '',
      drawer: false,
      bank_id: '',

      subject_id: '',
      problem_desc: '',
      innerDrawer: false,
      backPath: '',

      CurrentQuestion: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('beforeRouteEnter', 'to:', to)
    console.log('beforeRouteEnter', 'from:', from)
    next((vm) => {
      if (from.name) {
        vm.backPath = from.path
        window.sessionStorage.setItem('backPath', vm.backPath);
      } else {
        const backPath = window.sessionStorage.getItem('backPath');
        if (backPath) {
          vm.backPath = backPath;
          next()
        } else {
          vm.$message.error('警告：页面缺少必要参数，请从正确的路径进入此页面！')
        }
      }
    })
  },
  beforeRouteLeave(to, form, next) {
    window.sessionStorage.removeItem('backPath')
    next();
  },
  mounted() {
    this.title = this.$route.query.title
    // this.paper_id = this.$route.query.id;
    this.bank_id = this.$route.query.id
    this.subject_id = this.$route.query.subject_id

    this.getCheckPaperQuestionList()
  },
  methods: {
    BeautifyCode() {
      this.$nextTick(() => {
        console.log('元素已经渲染完毕')

        // 查找组件根元素下的<pre>元素
        const preElement = this.$el.querySelector('.hljs')
        const preElementPy = this.$el.querySelector('.language-python')
        const preElementCpp = this.$el.querySelector('.language-cpp')
        const preElementPyMd = this.$el.querySelector('.lang-python')
        const preElementCppMd = this.$el.querySelector('.lang-cpp')

        if (
          preElement ||
          preElementPy ||
          preElementCpp ||
          preElementPyMd ||
          preElementCppMd
        ) {
          // 页面包含<pre>元素
          console.log('页面包含<hljs>元素')
        } else {
          // 页面不包含<pre>元素
          console.log('页面不包含<hljs>元素')
          return
        }

        let timeoutId
        const intervalId = setInterval(() => {
          const numberElement = document.querySelector('.line-num-box')
          const lineNumbersRowsElement = document.querySelector(
            '.line-numbers-rows'
          )

          if (numberElement || lineNumbersRowsElement) {
            console.log('关闭定时器')
            clearInterval(intervalId)
            clearTimeout(timeoutId)
          } else {
            console.log('试图渲染行号')

            if (this.paperQuestionList[0].show_type == 2) {
              getcode()
            } else {
              Prism.highlightAll()
            }
          }
        }, 100)

        timeoutId = setTimeout(() => {
          console.log('超时，取消定时器')
          clearInterval(intervalId)
        }, 10000) // 10秒后取消定时器
      })
    },

    CloseDrawer() {
      this.drawer = false
      this.exam_url = ''
    },

    OpenDrawer() {
      this.innerDrawer = true
      console.log('题目说明')
    },

    ReadPyCode(url, callback) {
      Axios({
        method: 'get',
        url: url,
        responseType: 'text',
      }).then((res) => {
        callback(res.data)
      })
    },

    checkAddType() {
      console.log("强制刷新状态");
      this.$forceUpdate();
    },
    //点击答题卡
    ChooseQustion(ref, itemType, item) {
      console.log('点击答题卡')
      console.log(ref, itemType, item)
      document.getElementById(ref + 1).scrollIntoView()
      this.current_num = ref

      this.CurrentQuestion = this.paperQuestionList[ref]
      this.$nextTick(() => {
        getcode()
      })
    },

    QuestionModal(val) {
      this.showType = val.show_type

      console.log('挑战模板')
      console.log(val, 45323)

      if (this.subject_id == 2) {
        this.project_url = JSON.parse(val.options)[0].content

        console.log('挑战模板1')
        console.log(this.project_url)

        if (val.show_type === 1) {
          this.problem_desc = val.title
        } else {
          this.problem_desc = val.title_md
        }

        this.exam_url =
          '/scratch/exam-preview.html?project_url=' +
          this.project_url +
          '&project_title=挑战模板'

        this.drawer = true
      } else if (this.subject_id == 3) {
        var url = JSON.parse(val.options)[0].content
        this.ReadPyCode(url, (res) => {
          sessionStorage.setItem('py_exam_code', res)
          //sessionStorage.setItem("py_exam_desc", val.title);

          if (val.show_type === 1) {
            this.problem_desc = val.title
          } else {
            this.problem_desc = val.title_md
          }

          this.exam_url =
            '/python/exam_v2?type=4&operate=1&id=' + val.id + '&cmd=1'
          this.drawer = true
        })
      }
    },

    QuestionAnswer(val) {
      console.log('正确源码')
      console.log(val)
      this.CurrentQuestion.subject_id = val.subject_id
      this.showType = val.show_type

      if (this.subject_id == 2) {
        this.project_url = val.answer

        if (val.show_type === 1) {
          this.problem_desc = val.title
        } else {
          this.problem_desc = val.title_md
        }

        this.exam_url =
          '/scratch/exam-preview.html?project_url=' +
          this.project_url +
          '&project_title=正确源码'

        this.drawer = true
      } else if (this.subject_id == 3) {
        var url = val.answer

        if (val.show_type === 1) {
          this.problem_desc = val.title
        } else {
          this.problem_desc = val.title_md
        }

        this.ReadPyCode(url, (res) => {
          sessionStorage.setItem('py_exam_code', res)
          sessionStorage.setItem('py_exam_desc', val.title)
          this.exam_url = '/python/exam_v2?type=4&id=' + val.id + '&cmd=2'
          this.drawer = true
        })
      }
    },
    getCheckPaperQuestionList() {
      getSchoolQuestionList({
        questionBankId: this.bank_id,
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        console.log('试卷题目列表')
        console.log(res)
        res.questionList.map((item) => {
          item['radio'] = ''
          item['checked'] = []
        })
        this.paperQuestionList = res.questionList

        this.form_state.onechoice_arr = []
        this.form_state.onechoice_num = 0
        this.form_state.multi_choice_arr = []
        this.form_state.multi_choice_num = 0
        this.form_state.judge_choice_arr = []
        this.form_state.judge_choice_num = 0
        this.form_state.space_choice_arr = []
        this.form_state.space_choice_num = 0
        this.form_state.blank_choice_arr = []
        this.form_state.blank_choice_num = 0
        this.form_state.comprehensive_choice_arr = []
        this.form_state.comprehensive_choice_num = 0
        //新加阅读程序
        this.form_state.ReadingProgramNumList = []
        this.form_state.ReadingProgramNum = 0
        let ReadingProgramNumListArr = []
        let resultMap = {}
        // 新加完善程序
        this.form_state.ImproveTheProgramNumList = []
        this.form_state.ImproveTheProgramNum = 0
        let ImproveTheProgramListArr = []
        let resultMap1 = {}
        // 新加编程题
        this.form_state.programmingProblemList = []
        this.form_state.programmingProblemNum = 0;

        for (let k = 0; k < this.paperQuestionList.length; k++) {
          this.paperQuestionList[k].index = k
          this.paperQuestionList[k].answers = [false, false, false, false]; //多选题

          if (this.paperQuestionList[k].type == '1') {
            console.log('包含单选题')
            this.form_state.onechoice = true
            this.form_state.onechoice_num =
              parseInt(this.form_state.onechoice_num) + 1
            this.form_state.onechoice_arr.push(this.paperQuestionList[k])
          } else if (this.paperQuestionList[k].type == '2') {
            console.log('包含多选题')
            this.form_state.multi_choice = true
            this.form_state.multi_choice_num =
              parseInt(this.form_state.multi_choice_num) + 1
            this.form_state.multi_choice_arr.push(this.paperQuestionList[k])
          } else if (this.paperQuestionList[k].type == '3') {
            console.log('包含判断题')
            this.form_state.judge_choice = true
            this.form_state.judge_choice_num =
              parseInt(this.form_state.judge_choice_num) + 1
            this.form_state.judge_choice_arr.push(this.paperQuestionList[k])
          } else if (this.paperQuestionList[k].type == '4') {
            console.log('包含填空题')
            if (this.paperQuestionList[k].answer != '') {
              console.log(this.paperQuestionList[k].answer.split('┅'), 123456)
              this.paperQuestionList[k].tiankong_num = this.paperQuestionList[
                k
              ].answer.split('┅').length
            }
            this.form_state.space_choice = true
            this.form_state.space_choice_num =
              parseInt(this.form_state.space_choice_num) + 1
            this.form_state.space_choice_arr.push(this.paperQuestionList[k])
          } else if (this.paperQuestionList[k].type == '5') {
            console.log('包含简答题')
            this.form_state.blank_choice = true
            this.form_state.blank_choice_num =
              parseInt(this.form_state.blank_choice_num) + 1
            this.form_state.blank_choice_arr.push(this.paperQuestionList[k])
          } else if (this.paperQuestionList[k].type == '6') {
            console.log('包含综合题')
            this.form_state.comprehensive_choice = true
            this.form_state.comprehensive_choice_num =
              parseInt(this.form_state.comprehensive_choice_num) + 1
            this.form_state.comprehensive_choice_arr.push(
              this.paperQuestionList[k]
            )
          } else if (this.paperQuestionList[k].type == '7') {
            this.form_state.ReadingProgram = true
            this.form_state.ReadingProgramNum =
              parseInt(this.form_state.ReadingProgramNum) + 1
            ReadingProgramNumListArr.push(
              this.paperQuestionList[k]
            )
            this.ReadingProgramNumList1.push(
              this.paperQuestionList[k]
            )
          } else if (this.paperQuestionList[k].type == '8') {
            this.form_state.ImproveTheProgram = true
            this.form_state.ImproveTheProgramNum =
              parseInt(this.form_state.ImproveTheProgramNum) + 1
            ImproveTheProgramListArr.push(
              this.paperQuestionList[k]
            )
            this.ReadingProgramNumList2.push(
              this.paperQuestionList[k]
            )
          } else if (this.paperQuestionList[k].type == '9') {
            this.form_state.programmingProblem = true
            this.form_state.programmingProblemNum =
              parseInt(this.form_state.programmingProblemNum) + 1
            this.form_state.programmingProblemList.push(
              this.paperQuestionList[k]
            )
          }
        }

        this.form_state.ReadingProgramNumList = Object.values(resultMap)
        console.log(this.form_state.ReadingProgramNumList, 895656)
        ImproveTheProgramListArr.forEach((item) => {
          let code = item.code_other
          let titleOther = item.title_other
          let titleOtherMd = item.title_other_md
          let typeShow = item.show_type

          if (code in resultMap1) {
            resultMap1[code].arr.push(item)
          } else {
            resultMap1[code] = {
              code_other: code,
              title_other: titleOther,
              title_other_md: titleOtherMd,
              typeShow: typeShow,
              arr: [item],
            }
          }
        })
        this.form_state.ImproveTheProgramNumList = Object.values(resultMap1)
        console.log(this.form_state.ImproveTheProgramNumList, 895656111)

        console.log('试题列表')
        console.log(this.paperQuestionList)
        this.CurrentQuestion = this.paperQuestionList[0] || null;
        this.BeautifyCode()
      })
    },
    async handleProgrammingProblemDrawer(show, item = null) {
      if (item) {
        console.log(item)
        this.problemItem = item;
        const rs = await this.getTchGetOjProblemAnalysisList();
        if (!rs) {
          return this.$message.warning('暂无解析')
        }
      } else {
        this.problemItem = null
      }
      if (!show) {
        this.analyzeList = [];
        this.analyzeItem = null;
      }
      this.form_state.programmingProblemShow = show;
    },
    getTchGetOjProblemAnalysisList() {
      return tchGetOjProblemAnalysisList({
        language: 'all',
        title: '',
        problem_id: this.problemItem.oj_problem_id,
        isOwn: 0, // 0:全部 1:我的
        page_no: this.analyzePage.page_no,
        page_size: this.analyzePage.page_size,
      }).then(res => {
        this.analyzeList = res.ojProblemAnalysisList;
        this.analyzePage = {
          page_no: res.page_no,
          page_size: res.page_size,
          total: res.total
        }
        if (this.analyzeList.join('') !== '') {
          this.analyzeItem = this.analyzeList[0]
          return true;
        } else {
          return false;
        }
      })
    },
    handleSelectedAnalyzeItem(item) {
      this.analyzeItem = item;
    },
    handleChangePage(page) {
      this.analyzePage.page_no = page;
      this.getTchGetOjProblemAnalysisList()
    },
    copyText() {
      console.log(12345);
      var clipboard = new Clipboard(".tags");
      console.log(clipboard);

      clipboard.on("success", (e) => {
        console.log("复制成功");
        console.log(e);
        this.$message.success("复制成功");
        //  释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log(e);
        console.log("该浏览器不支持复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    // 查看学生OJ答案
    handleCodeMirrorInfoDrawer(show, item) {
      this.codeMirrorInfoShow = show
      if (item) {
        this.CurrentQuestion = item
      }
    }
  },
}
</script>

<style lang="scss" scoped>
/deep/ .hljs {
  background: transparent;
  // font-size: 18px;
}

/deep/.markdown-body code {
  font-size: 18px;
}

/deep/ .v-note-wrapper {
  border: 0px;
  z-index: 1;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}

.wrapper-paper {
  box-sizing: border-box;
  min-height: 100%;
  margin: 10px;
  padding: 20px;
  background: white;
  border-radius: 5px;
  overflow: hidden;

  .question {
    margin-top: 30px;

    .question-wrapper {
      padding: 5px;
      overflow-y: scroll;
      overflow-x: hidden;
      height: calc(100vh - 220px);

      .question-header {
        font-weight: bold;

        .question-label {
          line-height: 30px;
          font-size: 16px;
        }
      }

      .question-btn {
        float: right;
      }

      .question-content {
        display: inline-block;
        width: 100%;
        margin-top: 20px;
        font-size: 16px;

        .question-info {
          padding-bottom: 20px;

          .question-sort {
            float: left;
          }

          .question-title {
            width: 90%;
            float: left;
            margin-left: 10px;
            margin-bottom: 20px;
          }

          .question-score {
            float: left;
            margin-left: 20px;
            margin-bottom: 20px;
            font-size: 16px;
          }
        }

        .answer-options {
          margin-top: 20px;

          .option-wrapper {
            float: left;
            width: 95%;
            margin-bottom: 20px;
            margin-left: 20px;
            padding: 10px;
            border-radius: 10px;

            .option-tab {
              float: left;
              margin-left: 10px;
              font-weight: bold;
            }

            .option-input {
              float: left;
              width: calc(100% - 119px);
              margin-left: 10px;
              border-radius: 5px;
            }

            .el-icon-edit {
              margin-left: 10px;
              cursor: pointer;
            }
          }
          .option-wrapper:hover {
            border: 1px solid rgb(213, 217, 228);
            cursor: pointer;
          }
        }
      }

      .answer-check {
        .correct_label {
          font-weight: bold;
        }

        .correct_answer {
          color: orange;
          font-weight: bold;
          margin-left: 10px;
        }

        .myanswer_label {
          font-weight: bold;
          margin-left: 20px;
        }

        .myanswer {
          color: orange;
          font-weight: bold;
          margin-left: 10px;
        }

        .wrong {
          margin-left: 20px;
        }

        .correct {
          margin-left: 20px;
        }
      }

      .resolution {
        margin-top: 20px;

        .recolution-title {
          font-weight: bold;
          color: green;
        }

        .resolution-content {
          margin-top: 20px;
        }
      }
    }

    .answer-card {
      padding: 5px;
      overflow-y: auto;
      height: calc(100vh - 220px);

      .choice_item {
        margin-top: 20px;

        .tag {
          width: 50px;
          height: 50px;
          line-height: 50px;
          cursor: pointer;
          background: white;
          font-size: 16px;
          margin: 2px;
          text-align: center;
        }

        .tag_select {
          width: 50px;
          height: 50px;
          line-height: 50px;
          font-size: 16px;
          margin: 2px;
          text-align: center;

          cursor: pointer;
          background: rgb(236, 230, 230);
        }

        .tag_hasdone {
          width: 50px;
          height: 50px;
          line-height: 50px;
          cursor: pointer;
          background: #409eff;
          color: white;
          font-size: 16px;
          margin: 2px;
          text-align: center;
        }

        .choice_item_label {
          margin-bottom: 10px;
        }

        .choice_num {
        }
      }

      .onechoice {
        font-weight: bold;
      }

      .multichoice {
        font-weight: bold;
        margin-top: 10px;
      }
    }

    .el-icon-success {
      color: green;
    }

    .el-icon-error {
      color: red;
      margin-left: 20px;
    }

    .el-icon-s-data {
      color: orange;
      margin-left: 20px;
    }

    .answerinfo {
      margin-top: 20px;

      .answerinfo1 {
        margin-left: 5px;
        font-weight: bold;
      }

      .answerinfo1-1 {
        margin-left: 10px;
      }

      .answerinfo2 {
        margin-left: 5px;
        font-weight: bold;
      }

      .answerinfo2-1 {
        margin-left: 10px;
      }

      .answerinfo3 {
        margin-left: 5px;
        font-weight: bold;
      }

      .answerinfo3-1 {
        margin-left: 10px;
      }
    }

    .settings {
      font-weight: bold;
      color: #529dfe;
      margin-left: 5px;
    }

    .auto_change {
      margin-top: 15px;
      padding: 5px;
    }

    .show_answer {
      margin-top: 10px;
      padding: 5px;
    }

    .clearcontent {
      margin-top: 10px;
      margin-bottom: 10px;
      padding: 5px;
      float: right;
    }
  }
}

// /deep/ .v-note-wrapper .v-note-panel .v-note-show.single-show {
//   line-height: 1;
// }

/deep/.markdown-body code {
  font-size: 18px;
}
.el-drawer__body {
  .analyze-content,
  .codemirror-info-container {
    ::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      background: #f1f1f1;
      /*可以设置轨道颜色*/
      padding-right: 2px;
    }

    /*滚动条*/
    ::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 10px;
    }
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: #f1f7fe;
    .analyze-header,
    .codemirror-header {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 15px 30px;
      background-color: #1878ff;
    }
    .analyze-body {
      display: flex;
      height: 100%;
      padding: 20px;
      overflow: hidden;
      .analyze-left {
        width: 50%;
        padding: 15px;
        margin-right: 10px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 5px;
        .analyze-left-item {
          padding: 15px;
          border-bottom: 1px solid #f0f3f9;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.25s;
          &:hover {
            background-color: #efefef;
          }
          &.active {
            .title {
              strong {
                color: #409eff;
              }
            }
          }
          .title {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            img {
              width: 50px;
              margin-right: 20px;
              border-radius: 10px;
            }
            strong {
              margin-right: 20px;
              color: #000;
              font-size: 18px;
            }
          }
          .content {
            overflow: hidden;
            text-overflow: ellipsis;
            /* 超出部分省略号 */
            word-break: break-all;
            /* break-all(允许在单词内换行。) */
            display: -webkit-box;
            /* 对象作为伸缩盒子模型显示 */
            -webkit-box-orient: vertical;
            /* 设置或检索伸缩盒对象的子元素的排列方式 */
            -webkit-line-clamp: 2;
            /* 显示的行数 */
            line-height: 30px;
          }
        }
        .pagination {
          padding: 10px 0;
          text-align: right;
        }
      }
      .analyze-right {
        width: 50%;
        padding: 15px;
        overflow-y: auto;
        background-color: #fff;
        border-radius: 5px;
        .title {
          margin-bottom: 20px;
          font-size: 18px;
          font-weight: bold;
        }
        .stu-info {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          img {
            width: 50px;
            margin-right: 10px;
            border-radius: 10px;
          }
          span {
            margin-right: 15px;
            font-size: 14px;
            color: #333;
          }
        }
      }
    }
  }
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background: #f1f1f1;
  /*可以设置轨道颜色*/
  padding-right: 2px;
}

/*滚动条*/
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}
</style>

<style>
.wrapper-paper .el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
  font-weight: bold;
  border-bottom: 0px;
  background: #f9f9f9;
  text-align: center;
}

.wrapper-paper .el-drawer__body {
  overflow: hidden;
}

.v-note-wrapper {
  display: block !important;
  position: static !important;
}
</style>
